namespace TotalContest {
    import Service = TotalCore.Common.Service;

    @Service('services.totalcontest')
    export class RepositoryService {
        public resource;

        constructor($resource, prefix, ajaxEndpoint) {
            this.resource = $resource(ajaxEndpoint, {}, {
                activate: {method: 'GET', params: {action: `${prefix}_dashboard_activate`}},
                deactivate: {method: 'GET', params: {action: `${prefix}_dashboard_deactivate`}},
                account: {method: 'GET', params: {action: `${prefix}_dashboard_account`}},
                contestsOverview: {method: 'GET', params: {action: `${prefix}_dashboard_contests_overview`}, isArray: true},
                blogFeed: {method: 'GET', params: {action: `${prefix}_dashboard_blog_feed`}, isArray: true},
            });

            return this;
        }

        getContestsOverview() {
            return this.resource.contestsOverview().$promise;
        }

        postAccount(account) {
            return this.resource.account(account).$promise;
        }

        postActivation(activation) {
            return this.resource.activate(activation).$promise;
        }
        postDeactivation(){
            return this.resource.deactivate().$promise;
        }
        getBlogFeed() {
            return this.resource.blogFeed().$promise;
        }
    }
}
